import React, {useMemo} from "react";
import {Button, Divider, Modal, Stack} from "rsuite";

const ACK_MSG_BLURB = " By using this system you acknowledge that all data entered is unclassified and you have " +
    "gone through the correct channels for pre-publication, etc...";

const TopNavInfoModal = (props) => {
    const { handleClose, open } = props;

    return useMemo(() => {
            return (
                <Modal
                    backdrop="static"
                    role="alertdialog"
                    open={open}
                    onClose={handleClose}
                    keyboard={false}
                    size="md"
                >
                    <div className="main-content">
                        <h2>Info</h2>
                        <Stack spacing={20} direction='column' alignItems='flex-start'>
                            <p>
                                Welcome to the Synergist Resume Manager!
                                This tool is Synergist's collection and storage point for resumes.
                            </p>
                            <p>
                                THIS PRODUCT IS CURRENTLY IN BETA.
                                This site looks/performs best in Chrome, but has also been tested with Firefox.
                            </p>
                            <p>
                                Please navigate through all of the options on the left side bar to complete your resume.
                                Progress is saved per section.
                            </p>
                            <p>
                                Report bugs or issues to knowles.atchison[at]synergistcomputing.com
                            </p>
                        </Stack>
                        <Divider />
                        <Stack spacing={20} direction='column' alignItems='flex-start'>
                            <p>Thank you for for accepting this system's use requirements: </p>
                            <p><b>{ACK_MSG_BLURB}</b></p>
                        </Stack>
                        <Modal.Footer>
                            <Button onClick={handleClose} appearance="primary">
                                Ok
                            </Button>
                        </Modal.Footer>
                    </div>
                </Modal>
            );
        }, [handleClose, open]
    );
};

export default TopNavInfoModal;